<template>
  <div class="page">
    <div class="page-title">买房意向</div>
    <el-form :inline="true" :model="query" class="toolbar">
      <el-form-item>
        <el-select v-model="query.city" size="small" clearable placeholder="城市">
          <el-option v-for="c in cities" :key="c" :label="c" :value="c"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="query.createdDate"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          placeholder="提交日期"
          clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.status" size="small" clearable placeholder="状态">
          <el-option label="待处理" value="待处理"></el-option>
          <el-option label="已联系" value="已联系"></el-option>
          <el-option label="已关闭" value="已关闭"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border size="small" v-loading="loading">
      <el-table-column label="提交用户" width="160">
        <template slot-scope="scope">
          <div class="submit-user">
            <img v-if="scope.row.userUrl" :src="scope.row.userUrl" class="avatar" referrerpolicy="no-referrer">
            <span v-else class="avatar-ph"></span>
            <span>{{ scope.row.userName || '—' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="city" label="城市" width="90"></el-table-column>
      <el-table-column prop="location" label="期望位置" min-width="140"></el-table-column>
      <el-table-column prop="layout" label="期望户型" width="110"></el-table-column>
      <el-table-column prop="budget" label="预算(万)" width="100"></el-table-column>
      <el-table-column prop="contactName" label="称呼" width="90"></el-table-column>
      <el-table-column prop="phone" label="电话" width="130"></el-table-column>
      <el-table-column prop="status" label="状态" width="90"></el-table-column>
      <el-table-column prop="createdAt" label="提交时间" width="170" :formatter="fmtTime"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button v-if="canContact(scope.row)" type="text" size="mini" @click="setStatus(scope.row, '已联系')">已联系</el-button>
          <el-button v-if="canClose(scope.row)" type="text" size="mini" @click="setStatus(scope.row, '已关闭')">关闭</el-button>
          <span v-if="!canContact(scope.row) && !canClose(scope.row)" class="muted">—</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :child-msg="pageparm" @callFather="onPage"></Pagination>
  </div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { buyIntentPage, updateBuyIntentStatus, pageBody } from '../../api/spAdmin'
import citiesMixin from '../../mixins/cities'
export default {
  components: { Pagination },
  mixins: [citiesMixin],
  data() {
    return {
      loading: false,
      list: [],
      query: { status: '', city: '', createdDate: '' },
      pageparm: { currentPage: 1, pageSize: 10, total: 0 }
    }
  },
  created() { this.load() },
  methods: {
    fmtTime(row, col, val) {
      if (!val) return ''
      return String(val).replace('T', ' ').slice(0, 19)
    },
    canContact(row) {
      return row && row.status !== '已联系' && row.status !== '已关闭'
    },
    canClose(row) {
      return row && row.status !== '已关闭'
    },
    search() {
      this.pageparm.currentPage = 1
      this.load()
    },
    onPage(p) {
      this.pageparm.currentPage = p.currentPage
      this.pageparm.pageSize = p.pageSize
      this.load()
    },
    load() {
      this.loading = true
      const day = this.query.createdDate || ''
      buyIntentPage({
        page: this.pageparm.currentPage,
        limit: this.pageparm.pageSize,
        status: this.query.status,
        city: this.query.city,
        createdFrom: day,
        createdTo: day
      }).then(res => {
        if (!res || res.status !== 200) {
          this.list = []
          this.pageparm.total = 0
          this.loading = false
          this.$message.error((res && res.message) || '列表加载失败')
          return
        }
        const body = pageBody(res)
        this.list = body.list
        this.pageparm.total = body.total
        this.loading = false
      }, () => { this.loading = false })
    },
    setStatus(row, status) {
      if (row.status === '已关闭') {
        this.$message.warning('该意向已关闭，不能再改状态')
        return
      }
      if (status === '已联系' && row.status === '已联系') {
        return
      }
      updateBuyIntentStatus(row.id, status).then(res => {
        if (!res || res.status !== 200) {
          this.$message.error((res && res.message) || '更新失败')
          return
        }
        this.$message.success('已更新')
        this.load()
      }).catch(() => {})
    }
  }
}
</script>
<style scoped>
.page { padding: 8px 4px 24px; }
.page-title { font-size: 20px; font-weight: 800; color: #1f1633; margin-bottom: 16px; }
.toolbar { background: #fff; padding: 12px 12px 0; border-radius: 12px; margin-bottom: 12px; }
.muted { color: #9b95ae; font-size: 12px; }
.submit-user { display: flex; align-items: center; }
.avatar, .avatar-ph { width: 28px; height: 28px; border-radius: 50%; margin-right: 8px; flex-shrink: 0; }
.avatar { object-fit: cover; }
.avatar-ph { background: #e8edf3; display: inline-block; }
</style>



// WEBPACK FOOTER //
// src/views/housing/buyIntentList.vue